import { useT } from '../../../../i18n';
import { tachThoiLuong } from '../../nghiep-vu/tong-quan';

/** `1 giờ 2 phút`, `3 phút 5 giây`, `12 giây` theo ngôn ngữ đang xem — cùng chuỗi với bảng lượt chạy ở Dashboard. */
export function useThoiLuong(): (ms: number) => string {
  const { t } = useT();
  return (ms) => {
    const { gio, phut, giay } = tachThoiLuong(ms);
    if (gio > 0) return t('rpaTongQuan.thoiLuongGio', { gio, phut });
    if (phut > 0) return t('rpaTongQuan.thoiLuongPhut', { phut, giay });
    return t('rpaTongQuan.thoiLuongGiay', { giay });
  };
}
